import { Command } from '@/app/common/base/command'
import { Banner } from '@/app/banner/entities/banner.entity'

export class GetBannerCommand extends Command {
    public async run(): Promise<Banner> {
        const response = await this.client.get('/api/banners')
        return response.asEntity(Banner)
    }
}
